// extracted by mini-css-extract-plugin
module.exports = {"container":"messagesBalloon_container__2Guyf","container_answer":"messagesBalloon_container_answer__2-a-x","time":"messagesBalloon_time__2hMex"};